<script setup lang="ts"></script>

<template>
    <h1>Страница не найдена</h1>
</template>

<style scoped></style>
